module.exports = __webpack_public_path__ + "img/tree-06-b-leaves.17999149.png";